import React from "react";
import { Star } from "lucide-react";
import { AnimatedLines } from "@/components/landing/AnimatedLines";

const REVIEWS = [
  { id: "sylvie-r", author: "Sylvie R.", loc: "Belfort", text: "Toiture méconnaissable après démoussage. Rapide et soigné.", service: "Habitat" },
  { id: "julien-p", author: "Julien P.", loc: "Belfort", text: "Detailing complet + céramique : ma voiture brille comme au premier jour.", service: "Auto" },
  { id: "marc-d", author: "Marc D.", loc: "Montbéliard", text: "Terrasse en bois totalement restaurée, un travail de pro.", service: "Habitat" },
  { id: "nadia-b", author: "Nadia B.", loc: "Héricourt", text: "Intervention d'urgence après un dégât, réactivité impressionnante.", service: "Urgence" },
  { id: "thierry-l", author: "Thierry L.", loc: "Montbéliard", text: "Façade nettoyée impeccablement, devis clair et respecté.", service: "Habitat" },
  { id: "emilie-v", author: "Émilie V.", loc: "Belfort", text: "Contrat d'entretien mensuel pour le véhicule, très pratique.", service: "Auto" },
];

const STAR_KEYS = ["s1", "s2", "s3", "s4", "s5"];

const Card = ({ r }) => (
  <div className="w-[320px] shrink-0 bg-white border border-border rounded-sm p-6 mx-3">
    <div className="flex gap-1 mb-3">
      {STAR_KEYS.map((k) => (
        <Star key={k} className="w-4 h-4 fill-ink text-ink" />
      ))}
    </div>
    <p className="text-sm text-foreground/80 leading-relaxed">“{r.text}”</p>
    <div className="mt-4 flex items-center justify-between">
      <span className="font-heading font-bold text-ink text-sm">
        {r.author} · {r.loc}
      </span>
      <span className="text-[10px] uppercase tracking-wider font-bold text-foreground/60 bg-muted px-2 py-0.5 rounded-sm">
        {r.service}
      </span>
    </div>
  </div>
);

export const Testimonials = () => {
  const loop = [...REVIEWS, ...REVIEWS];
  return (
    <section data-testid="testimonials" className="relative py-16 md:py-24 bg-background overflow-hidden">
      <AnimatedLines />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 mb-10">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">
          Ils nous font confiance
        </span>
        <h2 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight text-ink mt-3">
          Avis clients vérifiés
        </h2>
      </div>
      <div className="relative z-10">
        <div className="flex marquee-track w-max">
          {loop.map((r, i) => (
            <Card key={`${r.id}-${i}`} r={r} />
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent pointer-events-none" />
      </div>
    </section>
  );
};
